import React, { useEffect, useState } from 'react';
import SoftInput from 'components/SoftInput';
import SoftBox from 'components/SoftBox';
import ApnaSelect from 'components/ApnaSelect';
import SoftButton from 'components/SoftButton';
import SoftTypography from 'components/SoftTypography';
import { useDispatch, useSelector } from 'react-redux';
import { getCategoryData } from 'api/commonSlice';
import { getSubCategoryData } from 'api/commonSlice';
import MultiTag from 'components/MultiTag/index';
import MultiTagBusiness from 'components/MultiTag/business';
import { baseURL } from 'utils/api';
import toast from 'react-hot-toast';
import ReactQuill from 'react-quill';
import SelectLocation from "components/location";
import LocationSearch from "layouts/authentication/sign-up/googleInput";
import { getKeywordsData } from 'api/commonSlice';
import ApplyModal from './ApplyModal';
import {
  Card,
  CircularProgress,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";


const GeneralInformation = ({ data, profile, handelRefresh }) => {

  
  const matches = useMediaQuery("(max-width:600px)");
  const dispatch = useDispatch();
  const [addressData, setAddressData] = useState('')
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [description, setDescription] = useState('');
  const keywords = useSelector((state) => state.commonSlice?.keywords);
  const [keywordIds, setKeywordIds] = useState([]);
  const [searchFirst, setSearchFirst] = useState(false);
  const [madeChanges, setMadeChanges] = useState(false);
  const [show, setShow] = useState(false);
  const [selectBranches, setSelectBranches] = useState([]);
  const [branches, setBranches] = useState([])
  const categoryData = useSelector((state) => state.commonSlice?.category);
  const subCategoryData = useSelector((state) => state.commonSlice?.subCategory)
  const id = localStorage.getItem("id");
  const [loading, setLoading] = useState(false);
  const userTheme = useSelector((state) => state.commonSlice.theme);


  useEffect(() => {
    const fetchData = async () => {
      try {
        fetch(`${baseURL}/profile/getBranches?userId=${id}`)
          .then((res) => res.json())
          .then((res) => {
            if (res.status) {
              setBranches(res?.profile);
            }
          });
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  const handleBranchChange = (event, value) => {
    setSelectBranches(value);
    setMadeChanges(true);
  };




  const [values, setValues] = useState({
    email: "",
    firstName: "",
    phoneNumber: "",
    category: "",
    subCategory: "",
    keywords: [],
    mainAddress: "",
    address: "",
    country: "",
    city: "",
    state: "",
    zipCode: "",
    county: "",
    fbLink: "",
    instagramLink: "",
    twitterLink: "",
    website: "",
    latitude: 0,
    longitude: 0,
    locationName: "",
  });
  useEffect(() => {
    if (data?.category?.id) {
      dispatch(getKeywordsData(data?.category?.id));
    }
  }, [data]);

  useEffect(() => {
    if (data) {
      // Set initial values
      setValues({
        email: data?.email || '',
        firstName: data?.firstName || '',
        phoneNumber: data?.mobileNumber || '',
        category: data?.category?.id || '',
        keywords: [], // Initialize as empty; will be updated below
        subCategory: data?.subCategory?.id || '',
        mainAddress: data?.addLine || '',
        address: data?.address || '',
        country: data?.country || '',
        city: data?.city || '',
        state: data?.state || '',
        zipCode: data?.zipcode || '',
        fbLink: data?.links?.fbLink || '',
        instagramLink: data?.links?.instagramLink || '',
        twitterLink: data?.links?.twitterLink || '',
        website: data?.links?.website || '',
        longitude: data?.location?.coordinates?.[0] || -82.46371629474554,
        latitude: data?.location?.coordinates?.[1] || 27.953573206285228,
        locationName: data?.locationName || '',
      });

      // Process keywords only if both 'data.keywords' and 'keywords' are available
      if (data?.keywords && keywords?.length > 0) {
        const newKeywords = [];
        keywords.forEach((item) => {
          const findKeyword = data?.keywords?.find(
            (keyword) => keyword?.keywordId === item?._id
          );
          if (findKeyword) {
            newKeywords.push(findKeyword);
          }
        });
        setValues((prevValues) => ({
          ...prevValues,
          keywords: newKeywords,
        }));
      } else {
        // If no data.keywords, ensure keywords are cleared
        setValues((prevValues) => ({
          ...prevValues,
          keywords: [],
        }));
      }

      // Update other states
      setSelectBranches([data]);
      setDescription(data?.description || '');

      // Fetch subcategories if category exists
      if (data?.category?.id) {
        dispatch(getSubCategoryData(data?.category?.id));
      }
    } else {
      // Reset all values when no data is available
      setValues({
        email: '',
        firstName: '',
        phoneNumber: '',
        category: '',
        subCategory: '',
        keywords: [],
        mainAddress: '',
        address: '',
        country: '',
        city: '',
        state: '',
        zipCode: '',
        county: '',
        fbLink: '',
        instagramLink: '',
        twitterLink: '',
        website: '',
        latitude: 0,
        longitude: 0,
        locationName: '',
      });
    }
  }, [data, keywords]); // Include 'keywords' in the dependency array



  useEffect(() => {
    if (addressData) {
      setValues({
        ...values,
        mainAddress: addressData?.address,
        address: addressData?.address,
        city: addressData?.city,
        state: addressData?.state,
        country: addressData?.country,
        zipCode: addressData?.zipcode,
      });
    }
  }, [addressData]);


  useEffect(() => {
    dispatch(
      getCategoryData(),
    );
  }, []);

  useEffect(() => {
    categoryData && categoryData?.length > 0 &&
      setCategories(categoryData?.map((item) => ({ name: item?.categoryName, _id: item?._id })))
  }, [categoryData]);

  useEffect(() => {
    subCategoryData && subCategoryData?.length > 0 &&
      setSubCategories(subCategoryData?.map((item) => ({ name: item?.categoryName, _id: item?._id })))
  }, [subCategoryData])


  const handleCategoryChange = (e) => {
    setValues({ ...values, category: e.target.value });
    dispatch(getSubCategoryData(e.target.value));
    // dispatch(getKeywordsData(e.target.value));
  };

  const onChangeSubCategory = (e) => {
    setValues({ ...values, subCategory: e.target.value });
  };

  const updateProfile = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (values.keywords.length === 0) {
      setLoading(false);
      toast.error('Please select keywords')
      return;
    }


    const findCityId = await fetch(`${baseURL}/get-id-for-address`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          cityName: values.city,
          stateName: values.state,
          countryName: values.country
        })
      }
    ).then(res => res.json());

    if (findCityId.status === 200) {
      values.city = findCityId.data?.id;
      values.state = findCityId.data?.state?.id;
      values.country = findCityId.data?.country?.id;
    }

    const formData = new FormData();
    formData.append('email', values.email)
    formData.append('mobileNumber', values.phoneNumber)
    formData.append('firstName', values.firstName)
    formData.append('category', values.category)
    formData.append('subCategory', values.subCategory)
    formData.append('description', description)
    formData.append('terms_and_conditions', undefined)
    formData.append('addLine', values.mainAddress)
    formData.append('subAddLine', values.city + ', ' + values.state + ', ' + values.zipCode)
    formData.append('country', values.country)
    formData.append('city', values.city)
    formData.append('state', values.state)
    formData.append('zipCode', values.zipCode)
    formData.append('latitude', values.latitude)
    formData.append('longitude', values.longitude)
    formData.append('locationName', values.locationName)
    formData.append('fb_link', values.fbLink)
    formData.append('instagramLink', values.instagramLink)
    formData.append('website', values.website);


    values.keywords && values.keywords.length > 0 && values.keywords.map((item, i) => {
      if (item.keywordId) {
        formData.append(`keywords[${i}][keywordId]`, item?.keywordId,)
        formData.append(`keywords[${i}][name]`, item?.name)
      } else {
        formData.append(`keywords[${i}][keywordId]`, item?._id,)
        formData.append(`keywords[${i}][name]`, item?.keyword)
      }
    });

    selectBranches && selectBranches.length > 0
    selectBranches.map((elm) => {
      formData.append(`branchIds[]`, elm._id)
    })


    // profile != null ? formData.append('profileImage', profile) : null;


    fetch(`${baseURL}/profile/updateProfile2/${data?._id}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: formData
    }).then(res => res.json())
      .then(data => {
        setLoading(false);
        if (data.status === 200) {
          handelRefresh();
          toast.success('Profile Updated Successfully')
        } else {
          toast.error(data.message)
        }
      }
      ).catch(err => {
        toast.error(err.message || 'Something went wrong');
      });
  };

  const handleChangeKeywords = (e, value) => {
    setValues({ ...values, keywords: value });
    setKeywordIds(value?.map(item => item?._id));
    setMadeChanges(true);
  }

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
    setMadeChanges(true);
  }




  return (
    <SoftBox>
      <ApplyModal description={description} show={show} unShow={setShow} values={values} />
      <form onSubmit={updateProfile}>
        <SoftBox noValidate autoComplete="off">
          <SoftBox       gap={matches?0:2} display="flex" flexDirection={matches ? 'column' : 'row'}>
            <SoftBox
              width={matches ? "100%" : "33%"}
            >
              <SoftTypography
                variant="caption"
              >
                Business Name
              </SoftTypography>

              <SoftInput
                disabled
                value={values.firstName}
                onChange={onChange}
                name="firstName"
                label="Business Name" placeholder="Enter Business Name" />
            </SoftBox>
            <SoftBox

              width={matches ? "100%" : "33%"}
              >
              <SoftTypography
                variant="caption"
              >
                Email
              </SoftTypography>

              <SoftInput
                disabled
                value={values.email}
                onChange={onChange}
                name="email"
                label="Email" placeholder="email@example.com" />

            </SoftBox>
            <SoftBox
              width={matches ? "100%" : "33%"}
            >
              <SoftTypography
                variant="caption">
                Phone Number *
              </SoftTypography>
              <SoftInput
                required
                value={values.phoneNumber}
                onChange={onChange}
                name="phoneNumber"
                label="Phone Number *"
                placeholder="(+02) 000-0000"
                type="tel"
              />
            </SoftBox>
          </SoftBox>


          <SoftBox 
           gap={2}
           display="flex" 
           >
            {/* Category Section */}

            <SoftBox width="50%">
              <SoftTypography
                variant="caption"
              >
                Category *
              </SoftTypography>
              <ApnaSelect
                required
                value={values.category}
                label="Category *"
                options={categories}
                onChange={handleCategoryChange}
              />
            </SoftBox>

            {/* Sub-category Section */}
            <SoftBox
              width="50%"
            >
              <SoftTypography
                variant="caption"
              >
                Sub-category *
              </SoftTypography>
              <ApnaSelect
                required
                label="Sub-category *"
                value={values.subCategory}
                options={subCategories}
                onChange={onChangeSubCategory}
              />
            </SoftBox>
          </SoftBox>

          <SoftTypography
            sx={{ marginBottom: 1, marginTop: 2 }}
            variant="h6"
            fontWeight="bold"
          >
            Address Details
          </SoftTypography>

          <SoftBox>
            <LocationSearch setSearchFirst={setSearchFirst} setMadeChanges={setMadeChanges} setValues={setValues} setAddressData={setAddressData} fetchApi={true} />
          </SoftBox>

          <SoftBox>
            <SoftTypography
              variant="caption"
            >
              Address
            </SoftTypography>
            <SoftInput
              disabled
              value={values.mainAddress}
              onChange={onChange}
              name="mainAddress"
              label="Main Address"
              placeholder="enter address"
            />
          </SoftBox>

          <SoftBox
            display="flex"
            flexDirection={matches ? 'column' : 'row'}
            justifyContent="space-between"
            gap={matches?0:2}
          >
            <SoftBox sx={{ width: "100%" }}>
              <SoftTypography
                variant="caption"
              >
                City *
              </SoftTypography>
              <SoftInput
                required
                disabled
                value={values.city}
                onChange={onChange}
                name="city"
                placeholder="Tampa"
                type="text"
              />
            </SoftBox>

            <SoftBox sx={{ width: "100%" }}>
              <SoftTypography
                variant="caption"
              >
                State *
              </SoftTypography>
              <SoftInput
                disabled
                required
                value={values.state}
                onChange={onChange}
                name="state"
                placeholder="FL"
                type="text"
              />
            </SoftBox>

            <SoftBox sx={{ width: "100%" }}>
              <SoftTypography
                variant="caption"
              >
                Country *
              </SoftTypography>
              <SoftInput
                required
                disabled
                value={values.country}
                onChange={onChange}
                name="country"
                placeholder="USA"
                type="text"
              />
            </SoftBox>
          </SoftBox>

          <SoftBox       gap={matches?0:2} display="flex" flexDirection={matches ? 'column' : 'row'}>

            <SoftBox sx={{ width: "100%" }}>
              <SoftTypography
                variant="caption"
              >
                Zip Code *
              </SoftTypography>
              <SoftInput
                required
                disabled
                value={values.zipCode}
                onChange={onChange}
                name="zipCode"
                placeholder="33602"
                type="number"
                min={6}
              />
            </SoftBox>

            <SoftBox sx={{ width: "100%" }}>
              <SoftTypography
                variant="caption"
              >
                Latitude
              </SoftTypography>
              <SoftInput
                value={values.latitude}
                disabled
                name="latitude"
                placeholder="27.9506"
                type="text"
              />
            </SoftBox>


            <SoftBox sx={{ width: "100%" }}>
              <SoftTypography
                variant="caption"
              >
                Longitude
              </SoftTypography>
              <SoftInput
                value={values.longitude}
                disabled
                name="longitude"
                placeholder="-82.4572"
                type="text"
              />
            </SoftBox>
          </SoftBox>

          <SoftBox mt={2}>
            <SelectLocation
              disabled={!searchFirst}
              lat={values.latitude}
              lng={values.longitude}
              setValues={setValues}
              setAddressData={setAddressData}
              fetchApi={true}
            />
          </SoftBox>

          <SoftBox>
            <SoftTypography
              variant="caption"
            >
              Location Name *
            </SoftTypography>
            <SoftInput
              required
              value={values.locationName}
              onChange={onChange}
              name="locationName"
              placeholder="Home"
              type="text"
            />
          </SoftBox>


          <Card className="glassmorphism-card"
            sx={{
              padding: 2,
              marginTop: 2
            }}
          >


            <SoftBox
             sx={{zIndex: 999}}
            >
              <SoftTypography
                variant="caption"
              >
                Description
              </SoftTypography>
              <div className={`quill-wrapper ${userTheme === 'dark' ? 'dark-theme' : ''}`}>
              <ReactQuill
                value={description}
                onChange={
                  (value) => {
                    setDescription(value);
                    setMadeChanges(true);
                  }
                }
                name="description"
                label="Description"
                placeholder="Enter a description"
              />
              </div>
            </SoftBox>
            
            {/* Keywords */}
            <SoftBox>
              <SoftTypography
                variant="caption"
              >
                Keywords *
              </SoftTypography>
              {
                keywords && keywords.length > 0 &&
                <MultiTag
                  required
                  value={values?.keywords || []}
                  label="Keywords *"
                  placeholder="Enter Keywords"
                  onChange={handleChangeKeywords}
                  data={keywords}

                />
              }

            </SoftBox>

            {/* Social Media */}
            <SoftTypography
              variant="h6"
              fontWeight="bold"
              marginTop={3}
              marginBottom={2}
            >
              Social Media Links
            </SoftTypography>
            <SoftBox> <SoftTypography variant="caption">Facebook URL </SoftTypography>
              <SoftInput sx={{ marginBottom: 2 }}
                name="fbLink"
                value={values.fbLink}
                onChange={onChange}
                label="Facebook URL" placeholder="Enter Facebook URL" />
            </SoftBox>
            <SoftBox> <SoftTypography variant="caption">Instagram URL </SoftTypography>
              <SoftInput sx={{ marginBottom: 2 }}
                name="instagramLink"
                value={values.instagramLink}
                onChange={onChange}
                label="Instagram URL" placeholder="Enter Instagram URL" />
            </SoftBox>

            <SoftBox> <SoftTypography variant="caption">Website </SoftTypography>
              <SoftInput sx={{ marginBottom: 2 }}
                name="website"
                value={values.website}
                onChange={onChange}
                label="Twitter URL" placeholder="Enter Twitter URL" />
            </SoftBox>
            <SoftBox> <SoftTypography variant="caption"> Apply the settings to the following locations </SoftTypography>

              {
                branches && branches.length > 0 &&
                <MultiTagBusiness
                  required
                  value={selectBranches || []}
                  label="branches *"
                  placeholder="Select branches"
                  onChange={handleBranchChange}
                  data={branches}
                />
              }
            </SoftBox>

          </Card>

          {/* Buttons */}
          <SoftBox sx={{ mt: 4 }}
            display="flex"
            justifyContent="space-between"
            gap={2}
          >
            <SoftButton variant="outlined" color="info"
              onClick={() => window.location.reload()}
              fullWidth
            >
              Cancel
            </SoftButton>
            <SoftButton
              fullWidth
              variant="gradient"
              color={madeChanges ? "info" : 'light'}
              disabled={!madeChanges}
              sx={{ marginRight: 2 }}
              type="submit"
            >
              {
                loading ? <CircularProgress size={24} color='white' /> : 'Save Changes'
              }
            </SoftButton>

          </SoftBox>
        </SoftBox>
      </form>
    </SoftBox>
  );
};



export default GeneralInformation;








